export default __webpack_public_path__ + "static/media/Elixir of Brute Force.fde04f3e.jpg";